<template>
  <div>
    <div class="slider-box">
      <el-carousel height="500px">
        <el-carousel-item v-for="(item, index) in sliders" :key="index">
          <a :href="item.url" target="_blank">
            <el-image :src="path + item.image" fit="cover" :title="item.title" class="slider-image"></el-image>
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="container news">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="calendar">
            <div class="calendar-header">
              <div class="calendar-header-left">
                <el-image src="https://xcx.qhzyjy.com/images/calendar_icon.png" fit="contain"
                          class="calendar-icon"></el-image>
                <div class="calendar-month">
                  <span class="calendar-month-num">{{ month }}</span>
                  <span>月</span>
                </div>
              </div>
              <div class="calendar-header-title">
                考试日历表
              </div>
            </div>
            <ul class="calendar-list">
              <li v-for="(item, index) in calendars" :key="index" class="calendar-item">
                <div class="calendar-item-title">{{ item.title }}</div>
                <div class="calendar-item-time">考试时间：{{ item.time }}</div>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="news-box">
            <div class="news-header">
              <div class="news-header-item">热门资讯</div>
              <div class="news-header-more" @click="goNews">
                查看更多>>
              </div>
            </div>
            <div class="news-list">
              <div class="news-item" v-for="(item, index) in newsHot" :key="index">
                <div class="news-item-title">
                  <a :href="'/news/details?id='+item.id" target="_blank">{{ item.title }}</a>
                </div>
                <div class="news-item-time">{{ $moment(item.created_at).format('YYYY-MM-DD') }}</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="guide">
            <div class="guide-header">
              <div class="guide-header-left">
                <el-image src="https://xcx.qhzyjy.com/images/guide.png" fit="contain" class="guide-icon"></el-image>
                <span class="guide-header-title">考试指南</span>
              </div>
              <div class="guide-header-right">
                <div class="guide-header-item" v-for="(item, index) in guideType" :key="index"
                     :class="[index === guideTypeIndex ? 'current' : '']" @click="changeGuide(index)">
                  {{ item }}
                </div>
              </div>
            </div>
            <div class="guide-list">
              <div class="guide-item" v-for="(item, index) in guides" :key="index">
                <div class="guide-item-title">
                  <a :href="item.course" target="_blank">{{ item.title }}</a>
                </div>
                <!--                <div class="guide-item-course">-->
                <!--                  <a :href="item.course" target="_blank">选课</a>-->
                <!--                </div>-->
                <div class="guide-item-vote">
                  <a :href="guideTypeIndex ? item.enroll : item.score" target="_blank">{{
                      guideType[guideTypeIndex]
                    }}</a>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="picture">
      <div class="picture-header">
        <div class="picture-header-icon">
          <el-image src="https://xcx.qhzyjy.com/images/head.png" fit="contain"
                    class="picture-icon picture-icon-1"></el-image>
        </div>
        <div class="picture-header-title">多重保障，为您的考试保驾护航！</div>
        <div class="picture-header-icon">
          <el-image src="https://xcx.qhzyjy.com/images/head.png" fit="contain"
                    class="picture-icon picture-icon-2"></el-image>
        </div>
      </div>
      <el-image src="https://xcx.qhzyjy.com/images/pic.png" fit="contain" class="picture-image"></el-image>
      <div class="picture-intro">
        <div class="picture-item">
          <div class="picture-item-box">
            <div class="picture-item-title">
              基础弱？不惧
            </div>
            <div class="picture-item-content">
              科学的备考考试方案，全真模拟练习，试卷精确解析试题，通过定向模拟实战，短时间内快速提升应试能力，迅速提升30%成绩。
            </div>
          </div>
        </div>
        <div class="picture-item">
          <div class="picture-item-box">
            <div class="picture-item-title">
              没时间？不怕
            </div>
            <div class="picture-item-content">
              根据智能测评报告，量身定制考前冲刺计划，最大程度利用有效时间只学重点、考点、核心得分点，掌握80%历年必考点。
            </div>
          </div>
        </div>
        <div class="picture-item">
          <div class="picture-item-box">
            <div class="picture-item-title">
              担心考不过？
            </div>
            <div class="picture-item-content">
              根据学员基础不同，量身定制专业化个性课程，以通过考试为主，高效定向模拟实战，通过无忧！
            </div>
          </div>
        </div>
        <div class="picture-item">
          <div class="picture-item-box">
            <div class="picture-item-title">
              苦学效率低？
            </div>
            <div class="picture-item-content">
              独家研发课程体系，一对一督学，更有专家24小时内在线答疑系统。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container course">
      <div class="index-header">
        <div class="index-header-title">特色课程</div>
        <div class="index-header-line-box">
          <div class="index-header-line">
            <div class="index-header-icon-box">
              <el-image src="https://xcx.qhzyjy.com/images/head.png" fit="contain"
                        class="index-header-icon"></el-image>
            </div>
          </div>
        </div>
        <div class="index-header-intro">
          以学员满意度、以学员学习效率为本
        </div>
      </div>
      <div class="course-list">
        <div class="course-item" v-for="(item, index) in courses" :key="index">
          <el-image :src="item.images && item.images.length > 0 ? path + item.images[0] : noneImg" fit="cover"
                    class="course-image"></el-image>
          <div class="course-title">{{ item.title }}</div>
          <div class="course-button">
            <el-button round @click="goCourse(item.id)">立即报名</el-button>
          </div>
        </div>
      </div>
      <div class="course-more">
        <el-button round @click="goCourseList">查看更多</el-button>
      </div>
    </div>
    <div class="teacher">
      <div class="container">
        <div class="index-header">
          <div class="index-header-title">名师荟萃</div>
          <div class="index-header-line-box">
            <div class="index-header-line">
              <div class="index-header-icon-box">
                <el-image src="https://xcx.qhzyjy.com/images/head.png" fit="contain"
                          class="index-header-icon"></el-image>
              </div>
            </div>
          </div>
        </div>
        <div class="teacher-list">
          <div class="teacher-item" v-for="(item, index) in teachers" :key="index">
            <div class="teacher-image-box" :class="{'left':index%2===0}">
              <div class="teacher-image-bg"></div>
              <el-image :src="path + item.image" fit="cover" class="teacher-image"></el-image>
            </div>
            <div class="teacher-info-box" :class="{'right':index%2===0}">
              <div class="teacher-info-header">
                <div>
                  <span class="teacher-info-header-header">{{ item.header }}</span>
                  <span class="teacher-info-header-pinyin">{{ item.pinyin }}</span>
                </div>
                <div>
                  <div class="teacher-info-header-title">{{ item.title }}</div>
                  <div class="teacher-info-header-designation">{{ item.designation }}</div>
                </div>
              </div>
              <div class="teacher-info-intro">
                {{ item.intro }}
              </div>
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="teaching">
      <div class="container">
        <div class="index-header">
          <div class="teaching-header-title">教学优势</div>
          <el-image src="https://xcx.qhzyjy.com/images/head_line.png" fit="contain" class="teaching-icon"></el-image>
          <div class="teaching-header-intro">
            以学员满意度、以学员学习效率为本
          </div>
        </div>
        <div class="teaching-list">
          <div class="teaching-item">
            <el-image src="https://xcx.qhzyjy.com/images/ai1.png" class="teaching-item-image"></el-image>
            <div class="teaching-item-title">基础智能评估</div>
            <div class="teaching-item-intro">
              针对每个学员进行一对一基础检测评估，找准薄弱之处，把握备考方向，针对性备考
            </div>
          </div>
          <div class="teaching-item">
            <el-image src="https://xcx.qhzyjy.com/images/ai2.png" class="teaching-item-image"></el-image>
            <div class="teaching-item-title">精准题库</div>
            <div class="teaching-item-intro">
              大数据分析典型试题，直击考试重点，难点，得分点，短时间内提升得分能力
            </div>
          </div>
          <div class="teaching-item">
            <el-image src="https://xcx.qhzyjy.com/images/ai3.png" class="teaching-item-image"></el-image>
            <div class="teaching-item-title">即时答疑</div>
            <div class="teaching-item-intro">
              一对一线上答疑，助学督导学习，解决每个考生的困惑点与疑难点，提高学习效率，加快学习进度，将学习付诸实施，考试事半功倍
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="study">
      <div class="container study-box">
        <div class="index-header">
          <div class="index-header-title">学习体系</div>
          <div class="index-header-line-box">
            <div class="index-header-line">
              <div class="index-header-icon-box">
                <el-image src="https://xcx.qhzyjy.com/images/head.png" fit="contain"
                          class="index-header-icon"></el-image>
              </div>
            </div>
          </div>
        </div>
        <div class="study-list">
          <div class="study-item">
            <el-image src="https://xcx.qhzyjy.com/images/study1.png" fit="contain"
                      class="study-item-icon"></el-image>
            <div class="study-item-title">一对一督促学习</div>
            <div class="study-item-body">
              学习顾问全程跟进，让学习有效性，备考通关更轻松
            </div>
          </div>
          <div class="study-item">
            <el-image src="https://xcx.qhzyjy.com/images/study2.png" fit="contain"
                      class="study-item-icon"></el-image>
            <div class="study-item-title">制定专业化课程</div>
            <div class="study-item-body">
              一对一制定专业化课程，以题带点，查缺补漏，针对性备考，省时省心
            </div>
          </div>
          <div class="study-item">
            <el-image src="https://xcx.qhzyjy.com/images/study3.png" fit="contain"
                      class="study-item-icon"></el-image>
            <div class="study-item-title">全程陪伴</div>
            <div class="study-item-body">
              学前、学中、考后全程个性化跟踪辅导，督促学习，24小时专家在线答疑，解决一切后顾之忧
            </div>
          </div>
          <div class="study-item">
            <el-image src="https://xcx.qhzyjy.com/images/study4.png" fit="contain"
                      class="study-item-icon"></el-image>
            <div class="study-item-title">智能学习引擎</div>
            <div class="study-item-body">
              大数据智能算法为学员分析提炼知识点，高效的答疑平台，多平台的在线学习，既保证学习的相对自由，又满足你的互动性和及时性的需求
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comment">
      <div class="container comment-box">
        <div class="comment-title">
          他们已加入了我们，在此学习，成就更好自己
        </div>
        <div class="comment-list">
          <vueSeamless :data="comments1" :class-option="optionLeft1" class="seamless-warp">
            <ul class="seamless-warp-item" :style="{width: innerWidth1 + 'px'}">
              <li v-for="(item, index) in comments1" :key="index" class="comment-item">
                <div class="comment-header">
                  <img :src="path + item.avatar" alt="" class="comment-header-avatar">
                  <div class="comment-header-name">{{ item.name }}</div>
                </div>
                <div class="comment-body">
                  {{ item.body }}
                </div>
                <!--                <div class="comment-time">-->
                <!--                  {{ $moment(item.time).format('YYYY-MM-DD') }}-->
                <!--                </div>-->
              </li>
            </ul>
          </vueSeamless>
          <div class="seamless-warp-2">
            <vueSeamless :data="comments2" :class-option="optionLeft2" class="seamless-warp">
              <ul class="seamless-warp-item seamless-warp-item2" :style="{width: innerWidth2 + 'px'}">
                <li v-for="(item, index) in comments2" :key="index" class="comment-item">
                  <div class="comment-header">
                    <img :src="path + item.avatar" alt="" class="comment-header-avatar">
                    <div class="comment-header-name">{{ item.name }}</div>
                  </div>
                  <div class="comment-body">
                    {{ item.body }}
                  </div>
                  <!--                  <div class="comment-time">-->
                  <!--                    {{ $moment(item.time).format('YYYY-MM-DD') }}-->
                  <!--                  </div>-->
                </li>
              </ul>
            </vueSeamless>
          </div>
          <div class="comment-list-l"></div>
          <div class="comment-list-r"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {request} from "@/utils/request";
import vueSeamless from 'vue-seamless-scroll'

export default {
  components: {
    vueSeamless
  },
  name: "Home",
  data() {
    return {
      sliders: [],
      path: process.env.VUE_APP_FILE,
      noneImg: process.env.VUE_APP_NONE,
      calendars: [],
      month: new Date().getMonth() + 1,
      newsHot: [],
      guideType: ['查分', '报名'],
      guideTypeIndex: 1,
      guides: [],
      courses: [],
      teachers: [],
      comments1: [],
      comments2: [],
      innerWidth1: 1200,
      innerWidth2: 1200
    }
  },
  computed: {
    optionLeft1() {
      return {
        direction: 2,
        limitMoveNum: this.comments1 ? this.comments1.length : 4,
        singleWidth: 0,
        hoverStop: false
      }
    },
    optionLeft2() {
      return {
        direction: 2,
        limitMoveNum: this.comments2 ? this.comments2.length : 4,
        singleWidth: 0,
        hoverStop: false
      }
    }
  },
  watch: {
    comments1(val) {
      this.innerWidth1 = val.length * 300
    },
    comments2(val) {
      this.innerWidth2 = val.length * 300
    }
  },
  created() {
    this.getSliders()
    this.getCalendar()
    this.getNewsHot()
    this.getGuides()
    this.getCoursesHot()
    this.getTeacher()
    this.getComments()
  },
  methods: {
    async getSliders() {
      try {
        let response = await request('sliders', {
          method: 'GET',
          params: {
            type: 2
          }
        })
        this.sliders = response.data.data
      } catch (e) {

      }
    },
    async getCalendar() {
      try {
        let response = await request('calendar', {
          method: 'GET'
        })
        this.calendars = response.data.data
      } catch (e) {

      }
    },
    async getNewsHot() {
      try {
        let response = await request('news/hot', {
          method: 'POST',
          data: {
            limit: 8,
            'filter[news_column_id]': 1
          }
        })
        this.newsHot = response.data.data
      } catch (e) {

      }
    },
    async getGuides() {
      try {
        let response = await request('guide', {
          method: 'GET'
        })
        this.guides = response.data.data
      } catch (e) {

      }
    },
    changeGuide(index) {
      this.guideTypeIndex = index
    },
    async getCoursesHot() {
      try {
        let response = await request('study/hot', {
          method: 'POST',
          data: {
            limit: 6
          }
        })
        this.courses = response.data.data
      } catch (e) {

      }
    },
    goCourse(id) {
      this.$router.push({path: '/course/' + id})
    },
    async getTeacher() {
      try {
        let response = await request('teacher', {
          method: 'GET'
        })
        this.teachers = response.data.data
      } catch (e) {

      }
    },
    async getComments() {
      try {
        let response = await request('comment', {
          method: 'GET'
        })
        let comments = response.data.data
        let comments1 = []
        let comments2 = []
        if (comments.length > 0) {
          comments.forEach((item, index) => {
            if (index % 2 === 0) {
              comments1.push(item)
            } else {
              comments2.push(item)
            }
          })
          this.comments1 = comments1
          this.comments2 = comments2
        }
      } catch (e) {

      }
    },
    goCourseList() {
      this.$router.push({path: '/course'})
    },
    goNews() {
      this.$router.push({
        path: '/news'
      })
    }
  }
}
</script>

<style scoped>
.slider-image {
  width: 100%;
  height: 500px;
}

.news {
  height: 400px;
  margin-top: 30px;
}

.calendar {
  background-image: url('https://xcx.qhzyjy.com/images/calendar.png');
  height: 400px;
  background-repeat: no-repeat;
}

.calendar-icon {
  width: 80px;
}

.calendar-header-left {
  position: relative;
}

.calendar-month {
  position: absolute;
  top: 26px;
  left: 18px;
  font-size: 16px;
  font-weight: bold;
}

.calendar-month-num {
  font-size: 24px;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.calendar-header-title {
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  padding-right: 20px;
}

.calendar-list {
  margin: 0 10px;
  padding: 10px;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, .3);
  height: 290px;
  overflow: auto;
}

.calendar-item {
  color: #ffffff;
  margin-bottom: 20px;
}

.calendar-item:last-child {
  margin-bottom: 0;
}

.calendar-item-title {
  font-size: 16px;
  font-weight: bold;
}

.calendar-list::-webkit-scrollbar {
  background-color: #ed887a;
}

.calendar-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #ed725a;
}

.news-title {
  font-size: 20px;
  font-weight: bold;
}

.news-box {
  background-color: #ffffff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, .03);
  height: 400px
}

.news-header {
  line-height: 50px;
  border-bottom: 1px solid #f3f3f3;
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
}

.news-header-item {
  border-bottom: 3px solid #2aacb2;
  font-size: 16px;
  font-weight: bold;
}

.news-list {
  padding: 0 20px;
}

.news-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  border-bottom: 1px dashed #ebebeb;
}

.news-item-title {
  width: 450px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.guide {
  background-color: #ffffff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, .03);
  height: 400px
}

.guide-header {
  line-height: 50px;
  border-bottom: 1px solid #f3f3f3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.guide-icon {
  width: 30px;
}

.guide-header-left {
  display: flex;
}

.guide-header-title {
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
}

.guide-header-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100px;
}

.guide-header-item {
  font-weight: bold;
  cursor: pointer;
  width: 50px;
  box-sizing: border-box;
  border-bottom: 3px solid #ffffff;
  text-align: center;
}

.guide-header-item.current {
  border-bottom: 3px solid #2aacb2;
  color: #2aacb2;
}

.guide-list {
  padding: 0 20px;
  overflow-y: scroll;
  max-height: 330px;
}

.guide-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  border-bottom: 1px dashed #ebebeb;
}

.guide-item-title {
  width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.guide-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.picture {
  margin-top: 80px;
}

.picture-header {
  display: flex;
  justify-content: center;
  align-items: center;
}

.picture-header-title {
  font-size: 5rem;
}

.picture-header-icon {
  position: relative;
}

.picture-icon {
  width: 50px;
  position: absolute;
}

.picture-icon-1 {
  left: -70px;
  bottom: 0;
}

.picture-icon-2 {
  right: -30px;
  top: 0;
}

.picture-image {
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  display: block;
}

.picture-intro {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #38a3a1;
  padding: 10px;
}

.picture-item {
  width: 25%;
  box-sizing: border-box;
  padding: 10px;
}

.picture-item-box {
  border: 1px solid #ffffff;
  padding: 20px;
  color: #ffffff;
  height: 145px;
}

.picture-item-title {
  font-size: 18px;
  border-bottom: 5px solid #ffdd00;
  display: inline-block;
}

.picture-item-content {
  margin-top: 20px;
}

.course {
  margin-top: 50px;
}

.index-header {
  text-align: center;
}

.index-header-title {
  font-size: 4rem;
}

.index-header-line-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  position: relative;
}

.index-header-line {
  width: 600px;
  height: 1px;
  background-color: #555555;
  display: flex;
  justify-content: center;
  align-items: center;
}

.index-header-icon-box {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -16px;
  left: 0;
  width: 100%;
}

.index-header-icon {
  width: 40px;
  padding: 0 20px;
  background-color: #f7f7f7;
}

.index-header-intro {
  margin-top: 20px;
  font-size: 18px;
  color: #888888;
}

.course-list {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.course-item {
  width: 360px;
  background-color: #ffffff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, .05);
  margin-bottom: 30px;
}

.course-title {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  padding: 10px 15px;
  text-align: center;
}

.course-button {
  text-align: center;
  padding-bottom: 10px;
}

.course-more {
  margin-top: 10px;
  text-align: center;
}

.teacher {
  margin-top: 40px;
  background-color: #ffffff;
}

.teacher .container {
  padding: 40px 0;
}

.teacher .index-header-icon {
  background-color: #ffffff;
}

.teacher-list {
  margin-top: 50px;
  background-color: #f3f3f3;
  padding: 60px 60px;
}

.teacher-item {
  margin-bottom: 50px;
}

.teacher-item:last-child {
  margin-bottom: 0;
}

.teacher-image-box {
  float: right;
  position: relative;
  width: 185px;
  height: 285px;
}

.teacher-image {
  width: 185px;
  height: 285px;
}

.teacher-image-bg {
  width: 185px;
  height: 285px;
  position: absolute;
  z-index: 0;
  bottom: -20px;
  right: -20px;
  background-color: #ebebeb;
}

.teacher-image-box.left {
  float: left;
}

.teacher-info-box {
  float: left;
  width: 800px;
}

.teacher-info-box.right {
  float: right;
}

.teacher-info-header-header {
  font-size: 7rem;
  font-weight: bold;
  color: #2aacb2;
}

.teacher-info-header-pinyin {
  font-size: 2rem;
  font-weight: bold;
  color: #999999;
}

.teacher-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed #999999;
}

.teacher-info-header-title {
  font-size: 3rem;
  color: #2aacb2;
}

.teacher-info-header-designation {
  font-size: 18px;
}

.teacher-info-intro {
  margin-top: 20px;
}

.teaching {
  background-image: url("https://xcx.qhzyjy.com/images/teaching.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 50px 0;
  color: #ffffff;
}

.teaching-icon {
  width: 600px;
  margin-top: 20px;
}

.teaching-header-title {
  font-size: 4rem;
}

.teaching-header-intro {
  font-size: 18px;
  margin-top: 20px;
}

.teaching-list {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}

.teaching-item {
  text-align: center;
  width: 320px;
}

.teaching-item-image {
  width: 100px;
  height: 100px;
}

.teaching-item-intro {
  margin-top: 30px;
}

.teaching-item-title {
  font-size: 16px;
  margin-top: 30px;
}

.comment {
  background-color: #efefef;
  padding: 50px 0;
}

.comment-title {
  font-size: 3rem;
  text-align: center;
}

.study {
  background-color: #ffffff;
  padding: 50px 0;
}

.study .index-header-icon {
  background-color: #ffffff;
}

.study-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
}

.study-item {
  border: 1px solid #999999;
  padding: 30px;
  text-align: center;
  width: 250px;
  height: 250px;
  box-sizing: border-box;
  border-radius: 20px;
}

.study-item-icon {
  width: 50px;
  height: 50px;
}

.study-item-title {
  margin-top: 15px;
  font-size: 16px;
  font-weight: bold;
}

.study-item-body {
  margin-top: 15px;
  color: #666666;
}

.seamless-warp {
  width: auto;
  overflow: hidden;
  height: 160px;
  box-sizing: border-box;
}

.comment-list {
  margin-top: 50px;
  position: relative;
  overflow: hidden;
}

.seamless-warp-item {
  box-sizing: border-box;
  height: 160px;
  overflow: hidden;
}

.comment-item {
  width: 270px;
  height: 130px;
  list-style-type: none;
  background-color: #ffffff;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
  margin: 15px;
  float: left;
}

.comment-header {
  display: flex;
  align-items: center;
}

.comment-header-avatar {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  object-fit: cover;
}

.comment-header-name {
  margin-left: 10px;
}

.comment-list-l {
  width: 200px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(to right, #efefef, transparent);
}

.comment-list-r {
  width: 100px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  background: linear-gradient(to left, #efefef, transparent);
}

.comment-body {
  font-size: 12px;
  color: #555555;
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.comment-time {
  text-align: right;
  color: #333333;
  font-size: 12px;
  margin-top: 2px;
}

.seamless-warp-2 {
  margin-left: -180px;
}

.news-header-more {
  color: #999999;
  font-size: 12px;
  cursor: pointer;
}

.news-header-more:hover {
  color: #2aacb2;
}
</style>
